// removed by extract-text-webpack-plugin
module.exports = {"content":"PasswordChangePage__content__hKWJZ","desktopTopbar":"PasswordChangePage__desktopTopbar__3gSBs","mobileTopbar":"PasswordChangePage__mobileTopbar__s-XQo","title":"PasswordChangePage__title__1_nNW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PasswordChangePage/PasswordChangePage.css
// module id = 2351
// module chunks = 0